import { render, staticRenderFns } from "./DriverTransportReportList.vue?vue&type=template&id=252e9b90&scoped=true"
import script from "./DriverTransportReportList.vue?vue&type=script&lang=js"
export * from "./DriverTransportReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e9b90",
  null
  
)

export default component.exports